"use strict";
/** Схемы направлений работы. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.reorderWorkstreamsSchema = exports.updateWorkstreamSchema = exports.createWorkstreamSchema = void 0;
const contracts_1 = require("@project-os/contracts");
const zod_1 = require("zod");
const common_1 = require("./common");
const workstreamNameSchema = zod_1.z
    .string()
    .trim()
    .min(1, 'Укажите название направления')
    .max(160, 'Название не длиннее 160 символов');
exports.createWorkstreamSchema = zod_1.z.object({
    name: workstreamNameSchema,
    descriptionMd: common_1.markdownSchema.nullish(),
    status: zod_1.z.enum(contracts_1.WORKSTREAM_STATUSES).default('NOT_STARTED'),
    ownerId: common_1.uuidSchema.nullish(),
});
exports.updateWorkstreamSchema = zod_1.z.object({
    name: workstreamNameSchema.optional(),
    descriptionMd: common_1.markdownSchema.nullish(),
    status: zod_1.z.enum(contracts_1.WORKSTREAM_STATUSES).optional(),
    ownerId: common_1.uuidSchema.nullish(),
});
/** Новый порядок направлений: полный список идентификаторов в нужной очерёдности. */
exports.reorderWorkstreamsSchema = zod_1.z.object({
    order: zod_1.z.array(common_1.uuidSchema).min(1, 'Список направлений пуст').max(200),
});
//# sourceMappingURL=workstreams.js.map